import React from "react";
import { FieldDisplayType } from "@/pages/settings/components/dealsSettings/FieldManagement/types";
import { BoolControl } from "./controls/BoolControl";
import { CountryControl } from "./controls/CountryControl";
import { CheckboxControl } from "./controls/CheckboxControl";
import { CheckboxWithTextControl } from "./controls/CheckboxWithTextControl";
import { ChecklistItemControl } from "./controls/ChecklistItemControl";
import { DateControl } from "./controls/DateControl";
import { DateRangeControl } from "./controls/DateRangeControl";
import { FileUploadControl } from "./controls/FileUploadControl";
import { MultiSelectControl } from "./controls/MultiSelectControl";
import { PhoneControl } from "./controls/PhoneControl";
import { SingleSelectControl } from "./controls/SingleSelectControl";
import { SwitchControl } from "./controls/SwitchControl";
import { TextControl } from "./controls/TextControl";
import { TextareaControl } from "./controls/TextareaControl";
import { UrlControl } from "./controls/UrlControl";
import { ControlProps, FieldControlProps } from "./types";

export type {
  CheckboxWithTextControlValue,
  DateRangeControlValue,
  FieldControlProps,
  FieldControlValue,
  MultiSelectSlots,
  SingleSelectSlots
} from "./types";

const CONTROL_BY_FIELD_TYPE: Record<string, React.FC<ControlProps>> = {
  [FieldDisplayType.TEXT]: TextControl,
  [FieldDisplayType.EMAIL]: TextControl,
  [FieldDisplayType.NUMBER]: TextControl,
  [FieldDisplayType.PERCENTAGE]: TextControl,
  [FieldDisplayType.CURRENCY]: TextControl,
  [FieldDisplayType.TEXTAREA]: TextareaControl,
  [FieldDisplayType.URL]: UrlControl,
  [FieldDisplayType.DATE]: DateControl,
  [FieldDisplayType.DATE_RANGE]: DateRangeControl,
  [FieldDisplayType.SINGLE_SELECT]: SingleSelectControl,
  [FieldDisplayType.PEOPLE_IN_COMPANY]: SingleSelectControl,
  [FieldDisplayType.MULTI_SELECT]: MultiSelectControl,
  [FieldDisplayType.SWITCH]: SwitchControl,
  [FieldDisplayType.BOOL]: BoolControl,
  [FieldDisplayType.CHECKBOX]: CheckboxControl,
  [FieldDisplayType.CHECKLIST_ITEM]: ChecklistItemControl,
  [FieldDisplayType.CHECKBOX_WITH_REQUIRED_TEXT]: CheckboxWithTextControl,
  [FieldDisplayType.FILE_UPLOAD]: FileUploadControl,
  [FieldDisplayType.COUNTRIES]: CountryControl,
  [FieldDisplayType.PHONE]: PhoneControl
};

// Unknown types fall back to a text input so they stay answerable.
export const FieldControl: React.FC<FieldControlProps> = ({
  className,
  ...props
}) => {
  const Control = CONTROL_BY_FIELD_TYPE[props.fieldType] ?? TextControl;

  return className ? (
    <div className={className}>
      <Control {...props} />
    </div>
  ) : (
    <Control {...props} />
  );
};
